import { useCallback, useMemo } from 'react'
import { Radio } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchRequestLog, DT_STR as S, type RequestLogRow } from './devtoolsApi'

/**
 * A27.02 — Инспектор запросов. Recent admin API calls (method/path/status/
 * duration/actor), read-only. Dormant until `/admin/devtools/requests` ships —
 * fetcher fail-soft to empty. Placeholder permission USERS_VIEW.
 */
export function RequestInspectorScreen() {
  const columns = useMemo<AdminColumn<RequestLogRow>[]>(
    () => [
      { key: 'at', header: S.at, type: 'text' },
      { key: 'method', header: S.method, type: 'text' },
      { key: 'path', header: S.path, type: 'text' },
      { key: 'status', header: S.status, type: 'number' },
      { key: 'duration_ms', header: S.duration, type: 'number' },
      { key: 'actor', header: S.actor, type: 'text' },
    ],
    [],
  )
  const fetcher = useCallback(fetchRequestLog, [])
  return (
    <>
      <PageHeader title={S.requestInspector} screenId="A27.02" />
      <DataTable<RequestLogRow>
        screenId="A27.02"
        permission={PERMISSIONS.USERS_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Radio size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
